import { parse } from 'date-fns';

export function timeToDate(time: string): Date {
    return parse(time === '24:00' ? '23:59' : time, 'HH:mm', new Date());
}
